<template>
    <div>
        <v-simple-table dense>
            <tbody>
                <tr>
                    <th>Code</th>
                    <td>{{value.code}}</td>
                </tr>
                <tr>
                    <th>Name</th>
                    <td>{{value.name}}</td>
                </tr>
                <tr>
                    <th>Group</th>
                    <td>{{value.group ? value.group.name : null}}</td>
                </tr>
                <tr>
                    <th>Phone</th>
                    <td>{{value.phone}}</td>
                </tr>
                <tr>
                    <th>Email</th>
                    <td>{{value.email}}</td>
                </tr>
                <tr>
                    <th>Address</th>
                    <td>{{value.address}}</td>
                </tr>
            </tbody>
        </v-simple-table>
    </div>
</template>

<script>

export default {
    name: "Supplier",
    components: {
        
    },
    props: {
        value: {
            type: Object
        }
    }
}
</script>

<style>

</style>